<template>
  <footer class="footer">
    <div class="container-fluid">
  
      <div class="copyright pull-right">
        Copyright <i class="fa fa-copyright" style="font-weight: 200"></i> {{ year }},
        <a href="#" target="_blank" rel="noopener"
          >Home Design Furniture. </a
        >
         All Rights Reserved.
       
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  data() {
    return {
      year: new Date().getFullYear(),
    };
  },
};
</script>
<style>

</style>
